import React from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import { textFieldDefaults } from "../formControlDefaults.js";

Textarea.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function Textarea(props) {
  const {
    item,
    value = false,
    error = null,
    onChange,
    showErrorText = false,
    disabled = false,
  } = props;

  let inputValue = value;
  if (!value) inputValue = "";

  let helperText = "";
  if (showErrorText) helperText = error;

  return (
    <TextField
      {...textFieldDefaults}
      label={item.label}
      name={item.name}
      value={inputValue}
      onChange={onChange}
      disabled={disabled}
      rows={item.rows}
      multiline
      {...(error && { error: true, helperText: helperText })}
    />
  );
}
